module.exports = __webpack_public_path__ + "media/images/flags/so-235bc70512df40eecb37fc554cd778de.svg";